import React, {FC} from 'react';

import {useCookies} from '@optimaxdev/utils';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';
import {isUhcEnabled} from 'libs/rollout';

import {getIsCartHasVista} from '../../../../store/selectors';

export type PropsType = {
    fallback?: React.ReactNode;
    isSubscriptionAvailable?: boolean;
    isVistaInCart: boolean;
    children: React.ReactNode;
};

/**
 *  Wrapper for Cl Subscription feature also checking on isSubscriptionAvailable and UHC
 *  @params {PropsType} - props
 *  @returns {React.ReactElement} - rendered component
 */
export const CLSubscriptionFeature: FC<PropsType> = ({
    children,
    fallback = null,
    isSubscriptionAvailable,
    isVistaInCart,
}) => {
    const [cookies] = useCookies();
    if (!isSubscriptionAvailable || isUhcEnabled(cookies) || isVistaInCart) return <>{fallback}</>;

    return <>{children}</>;
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    isVistaInCart: getIsCartHasVista(store),
});

export const CLSubscriptionFeatureConnected = connect(mapStateToProps)(CLSubscriptionFeature);
